

import {
  BASE_URL,
  ADMIN_API,
  BASE_API,
  CLIENT_API
} from "@/config";

export const apiConstants = {
  // clients: `${BASE_API}/clients`,
  clientsPanel: `${ADMIN_API}/clients`,
  dashboard : `${ADMIN_API}/dashboard`,
  client:  `${CLIENT_API}/clients`,
  group: `${ADMIN_API}/groups`

}
